import { render, staticRenderFns } from "./MostsalesProductSlider.vue?vue&type=template&id=1dcff508&scoped=true&"
import script from "./MostsalesProductSlider.vue?vue&type=script&lang=js&"
export * from "./MostsalesProductSlider.vue?vue&type=script&lang=js&"
import style0 from "./MostsalesProductSlider.vue?vue&type=style&index=0&id=1dcff508&scoped=true&lang=css&"
import style1 from "./MostsalesProductSlider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcff508",
  null
  
)

export default component.exports